/**
 * nhóm nhiệm vụ chi
 */
export default {
  Regular: 5,
  NotRegular: 10,
  AssignedByState: 15,
};
